export const STATUS_STYLE = {
  P: "bg-emerald-50 text-emerald-800 border-emerald-200",
  OD: "bg-emerald-50 text-emerald-700 border-emerald-200",
  WO: "bg-slate-100 text-slate-500 border-slate-200",
  H: "bg-sky-50 text-sky-700 border-sky-200",
  HD: "bg-amber-50 text-amber-800 border-amber-200",
  L: "bg-rose-50 text-rose-700 border-rose-200",
  A: "bg-rose-100 text-rose-800 border-rose-300",
};

export const MONTHS_LONG = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const fmtN = (v) => (v == null ? "—" : Number.isInteger(Number(v)) ? String(v) : Number(v).toFixed(1));

export const fmt12 = (hhmm) => {
  if (!hhmm) return "—";
  const [h, m] = hhmm.split(":").map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};
